export interface VideoReconocido {
  provider: 'youtube' | 'vimeo';
  videoId: string;
  embedUrl: string;
}

/** Id del proveedor a partir de una URL de YouTube o Vimeo (misma regla que la API). */
export function reconocerVideo(entrada: string): VideoReconocido | null {
  const s = entrada.trim();
  let id: string | null = null;
  let m: RegExpMatchArray | null;
  if (/^\d{5,15}$/.test(s)) id = s;
  else if (
    (m = s.match(/vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d{5,15})/i))
  )
    id = m[1] ?? null;
  else if (
    (m = s.match(
      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{6,20})/i,
    ))
  )
    id = m[1] ?? null;
  else if (/^[A-Za-z0-9_-]{6,20}$/.test(s)) id = s;
  if (!id) return null;
  const vimeo = /^\d+$/.test(id);
  return {
    provider: vimeo ? 'vimeo' : 'youtube',
    videoId: id,
    embedUrl: vimeo
      ? `https://player.vimeo.com/video/${id}`
      : `https://www.youtube-nocookie.com/embed/${id}?rel=0`,
  };
}

/** URL para abrir el video en su sitio (para mostrar y editar). */
export function urlDeVideo(v: { provider: string | null; videoId: string } | null): string {
  if (!v) return '';
  if (v.provider === 'vimeo') return `https://vimeo.com/${v.videoId}`;
  if (v.provider === 'youtube') return `https://www.youtube.com/watch?v=${v.videoId}`;
  return v.videoId;
}
